import '@babel/polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'slick-carousel';
import 'magnific-popup';

svg4everybody();

window.$ = $;
window.jQuery = $;

require('ninelines-ua-parser');

// init slick-carousel

let clientsResultsSettings = {
	dots: true,
	arrows: true,
  slidesToShow: 3,
	slidesToScroll: 1,
	infinite: true,
	adaptiveHeight: true,
	prevArrow: '.arrows__item--prev',
	nextArrow: '.arrows__item--next',
	responsive: [
		{
			breakpoint: 1200,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			}
		},
	]
}

$('[data-slick="clients-results"]').slick(clientsResultsSettings);

$(document).ready(function() {
	$('.js-hamburger').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#name',

		callbacks: {
			beforeOpen: function() {
				if($(window).width() < 700) {
					this.st.focus = false;
				} else {
					this.st.focus = '#name';
				}
			}
		}
	});
});